import { Box, Button } from "@mui/material";
import { DataGridPro, GridCellParams, GridColDef } from "@mui/x-data-grid-pro";
import { datagridcolumns } from "./datagridcolumns";
import ViewTabs from "./ViewTabs";
import { datagridmodigficationcolumns } from "./datagridcolumns";
import ActivitySummary from "./ActivitySummary";
import { useState, useEffect } from "react";
const AuthorizationReport = (props: any) => {
  const getRowClassName = (params: GridCellParams) => {
    return params.row.id === 1 ? 'firstRow' : '';
  };
    const [rowData, setRowData] = useState<any>()
   
   
    useEffect(() => {
    
      setRowData(props?.data)
    
  }, [props?.data])


  return (
    <>
    

      <Box className="dashboard-table-wrapper">
        <div style={{ width: "100%" }}>
          <DataGridPro
            className="custom-data-grid"
            loading={props?.loading}         
            getRowId={(row) => row.uniqueId}
            rows = {rowData ?? []}
            columns={props.selected === 0 ? datagridcolumns : datagridmodigficationcolumns}
            columnHeaderHeight={48}
            headerFilterHeight={48}
            pageSizeOptions={[2, 10, 100]}
            rowHeight={40}
            disableRowSelectionOnClick
            pagination
            disableColumnMenu={true}
            autoHeight
            hideFooter={false}
          />
        </div>
      </Box>
    </>
  );
};

export default AuthorizationReport;